export const messages = {
  en: {
    systemInfo: {
      title: 'System Configuration',
      editTitle: 'Edit System Configuration',
      systemTitle: 'System Title',
      subSystemTitle: 'Sub System Title',
      systemSimpleTitle: 'System Simple Title',
      companyName: 'Company Name',
      logoUrl: 'Logo URL',
      imgUrl: 'Image URL',
      defaultCommunityId: 'Default Community ID',
      ownerTitle: 'Owner Title',
      propertyTitle: 'Property Title',
      qqMapKey: 'QQ Map Key',
      mallUrl: 'Mall URL',
      required: '{field} is required',
      maxLength: '{field} cannot exceed {length} characters',
      fetchError: 'Failed to fetch system information'
    },
    searchCommunityData: {
      title: 'Search',
      placeholder: 'Please enter house number, owner name, car number or family member name, etc.',
      callInNumber: 'Calling number',
      noData: 'Sorry, no data available',
      inputTip: 'Please enter search criteria',
      telNotConnected: 'Fixed telephone not connected',
      noCallInNumber: 'No calling number returned from the telephone',
      roomInfo: 'Room Information',
      ownerInfo: 'Owner Information',
      ownerMember: 'Owner Member',
      communityCar: 'Community Vehicle',
      memberCar: 'Member Vehicle',
      contract: 'Contract',
      repairOrder: 'Repair Order',
      visitor: 'Visitor',
      staff: 'Staff',
      roomPlaceholder: 'Please enter room number like building-unit-room, e.g. 1-1-1'
    }
    
  },
  zh: {
    systemInfo: {
      title: '系统配置',
      editTitle: '修改系统配置',
      systemTitle: '标题名称',
      subSystemTitle: '副标题',
      systemSimpleTitle: '简写名称',
      companyName: '公司名称',
      logoUrl: 'logo地址',
      imgUrl: '静态url',
      defaultCommunityId: '默认小区编号',
      ownerTitle: '业主标题',
      propertyTitle: '物业手机标题',
      qqMapKey: 'QQ地图key',
      mallUrl: '商城地址',
      required: '{field}不能为空',
      maxLength: '{field}不能超过{length}个字符',
      fetchError: '获取系统信息失败'
    },
    searchCommunityData: {
      title: '搜索',
      placeholder: '请输入房屋编号，业主名称，车辆编号或者家庭成员名称等',
      callInNumber: '通话中号码',
      noData: '抱歉，没有数据',
      inputTip: '请输入查询条件',
      telNotConnected: '未连接固定电话',
      noCallInNumber: '座机未返回通话中号码',
      roomInfo: '房屋信息',
      ownerInfo: '业主信息',
      ownerMember: '业主成员',
      communityCar: '小区车辆',
      memberCar: '成员车辆',
      contract: '合同',
      repairOrder: '报修工单',
      visitor: '访客',
      staff: '员工',
      roomPlaceholder: '请输入房屋编号 楼栋-单元-房屋 如1-1-1'
    }
  },
  'zh-TW': {
    systemInfo: {
      title: '系統配置',
      editTitle: '修改系統配置',
      systemTitle: '標題名稱',
      subSystemTitle: '副標題',
      systemSimpleTitle: '簡寫名稱',
      companyName: '公司名稱',
      logoUrl: 'logo地址',
      imgUrl: '靜態url',
      defaultCommunityId: '默認小區編號',
      ownerTitle: '業主標題',
      propertyTitle: '物業手機標題',
      qqMapKey: 'QQ地圖key',
      mallUrl: '商城地址',
      required: '{field}不能為空',
      maxLength: '{field}不能超過{length}個字符',
      fetchError: '獲取系統信息失敗'
    },
    searchCommunityData: {
      title: '搜尋',
      placeholder: '請輸入房屋編號，業主名稱，車輛編號或者家庭成員名稱等',
      callInNumber: '通話中號碼',
      noData: '抱歉，沒有數據',
      inputTip: '請輸入查詢條件',
      telNotConnected: '未連接固定電話',
      noCallInNumber: '座機未返回通話中號碼',
      roomInfo: '房屋信息',
      ownerInfo: '業主信息',
      ownerMember: '業主成員',
      communityCar: '小區車輛',
      memberCar: '成員車輛',
      contract: '合同',
      repairOrder: '報修工單',
      visitor: '訪客',
      staff: '員工',
      roomPlaceholder: '請輸入房屋編號 樓棟-單元-房屋 如1-1-1'
    }
  }
}